import { render, staticRenderFns } from "./view-overrides-modal.vue?vue&type=template&id=30222867&scoped=true"
import script from "./view-overrides-modal.vue?vue&type=script&lang=js"
export * from "./view-overrides-modal.vue?vue&type=script&lang=js"
import style0 from "./view-overrides-modal.vue?vue&type=style&index=0&id=30222867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30222867",
  null
  
)

export default component.exports